import styled from 'styled-components';
import InfoIcon from '../../icons/info.svg';
import PorscheCloseIcon from '../../icons/porscheCloseIcon.svg';
import DefaultInfoMessageBox, { type InfoMessageBoxProps } from '../default/InfoMessageBox';

const InfoText = styled(DefaultInfoMessageBox)`
    border: 0;
    border-left: 0.25rem solid rgb(0, 97, 189);
`;

const InfoMessageBox = (props: Omit<InfoMessageBoxProps, 'icon' | 'closeIcon'>) => (
    <InfoText closeIcon={PorscheCloseIcon} icon={InfoIcon} {...props} />
);

export default InfoMessageBox;
